<script setup lang="ts">
import { computed, ref, provide } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AppHeader from './AppHeader.vue'
import ToastContainer from '../common/ToastContainer.vue'

const route = useRoute()
const authStore = useAuthStore()
const toastRef = ref<InstanceType<typeof ToastContainer> | null>(null)

const showHeader = computed(() => {
  return route.meta.hideNav !== true && authStore.isAuthenticated
})

// Provide toast function to all children
function showToast(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
  toastRef.value?.show(message, type)
}

provide('toast', showToast)
</script>

<template>
  <div class="app-layout">
    <AppHeader />
    <main class="main-content" :class="{ 'no-header': !showHeader }">
      <slot />
    </main>
    <ToastContainer ref="toastRef" />
  </div>
</template>

<style scoped>
.app-layout {
  min-height: 100vh;
}

.main-content {
  padding-top: 70px;
  min-height: 100vh;
}

.main-content.no-header {
  padding-top: 0;
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 120px;
  }
}
</style>
